var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { staticClass: "card", class: _vm.isMobile ? "mt-16px" : "mt-30px" },
    [
      _c("h2", { class: _vm.isMobile ? "mb-8px" : "mb-15px" }, [
        _vm._v(_vm._s(_vm.nazovProduktu))
      ]),
      _vm.visiblePoplatky
        ? [
            !_vm.isMobile
              ? _c("div", { staticClass: "f18" }, [_vm._v("Poplatky")])
              : _vm._e(),
            _c("v-divider", {
              staticClass: "mt-2",
              class: { "mb-3": !_vm.isMobile }
            }),
            !_vm.isMobile
              ? [
                  _c(
                    "v-row",
                    { staticClass: "mt-10px px-12px mx-0px" },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "pa-0px",
                          attrs: { xl: "6", lg: "6", md: "6" }
                        },
                        [
                          _c("span", { staticClass: "f14 gs100 bold" }, [
                            _vm._v("Názov poplatku")
                          ])
                        ]
                      ),
                      _c("v-col", { attrs: { xl: "2", lg: "2", md: "2" } }, [
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.poplatkyVisiblePerc,
                                expression: "poplatkyVisiblePerc"
                              }
                            ],
                            staticClass: "f14 gs100 right bold"
                          },
                          [_vm._v("Výška v %")]
                        )
                      ]),
                      _c("v-col", { attrs: { xl: "2", lg: "2", md: "2" } }, [
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.poplatkyVisibleZakl,
                                expression: "poplatkyVisibleZakl"
                              }
                            ],
                            staticClass: "f14 gs100 right bold"
                          },
                          [_vm._v("Základ")]
                        )
                      ]),
                      _c("v-col", { attrs: { xl: "2", lg: "2", md: "2" } }, [
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.poplatkyVisibleSDph,
                                expression: "poplatkyVisibleSDph"
                              }
                            ],
                            staticClass: "f14 gs100 right bold"
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.jeDealer ? "Spolu" : "Cena s DPH")
                            )
                          ]
                        )
                      ])
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.spPoplVisible,
                          expression: "spPoplVisible"
                        }
                      ],
                      staticClass: "poplatok-row px-12px mx-0px",
                      attrs: { "no-gutters": "" }
                    },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "pl-0px",
                          attrs: { xl: "6", lg: "6", md: "6" }
                        },
                        [
                          _c("span", { staticClass: "f16" }, [
                            _vm._v(_vm._s(_vm.sp_popl.nazov))
                          ])
                        ]
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "px-11px",
                          attrs: { xl: "2", lg: "2", md: "2" }
                        },
                        [
                          _c("numeric-text-box", {
                            key:
                              "liw_filip__wiz_kalkulacia_produkt__txt_sprac_popl_perc" +
                              _vm.cisloPlz,
                            ref: "sprac_popl_perc",
                            attrs: {
                              dense: "",
                              dynamic: "",
                              parentReloaded: _vm.produktFormReloaded,
                              cisloPlz: _vm.cisloPlz,
                              dataId:
                                "liw_filip__wiz_kalkulacia_produkt__txt_sprac_popl_perc",
                              cisloPredmetu: _vm.cisloPredmetu,
                              suffix: "%",
                              textRight: "",
                              "hide-details": "",
                              "hide-label": "",
                              disabled: _vm.isCalculating,
                              decimalPlaces: 3,
                              replaceNull: ""
                            },
                            on: {
                              valueChanged: _vm.spracPoplPercValueChanged,
                              dataLoaded: function($event) {
                                return _vm.visiblePoplatkyHeader(
                                  "sprac_popl",
                                  "perc"
                                )
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "px-11px",
                          attrs: { xl: "2", lg: "2", md: "2" }
                        },
                        [
                          _c("numeric-text-box", {
                            key:
                              "liw_filip__wiz_kalkulacia_produkt__txt_sprac_popl_zakl" +
                              _vm.cisloPlz,
                            ref: "sprac_popl_zakl",
                            attrs: {
                              dense: "",
                              dynamic: "",
                              parentReloaded: _vm.produktFormReloaded,
                              cisloPlz: _vm.cisloPlz,
                              dataId:
                                "liw_filip__wiz_kalkulacia_produkt__txt_sprac_popl_zakl",
                              cisloPredmetu: _vm.cisloPredmetu,
                              suffix: "€",
                              textRight: "",
                              "hide-details": "",
                              "hide-label": "",
                              disabled: _vm.isCalculating || !_vm.jeDealer,
                              decimalPlaces: 2,
                              replaceNull: ""
                            },
                            on: {
                              valueChanged: _vm.spracPoplZaklValueChanged,
                              dataLoaded: function($event) {
                                return _vm.visiblePoplatkyHeader(
                                  "sprac_popl",
                                  "zakl"
                                )
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "px-11px",
                          attrs: { xl: "2", lg: "2", md: "2" }
                        },
                        [
                          _c("numeric-text-box", {
                            key:
                              "liw_filip__wiz_kalkulacia_produkt__txt_sprac_popl_s_dph" +
                              _vm.cisloPlz,
                            ref: "sprac_popl_s_dph",
                            attrs: {
                              dense: "",
                              dynamic: "",
                              parentReloaded: _vm.produktFormReloaded,
                              cisloPlz: _vm.cisloPlz,
                              dataId:
                                "liw_filip__wiz_kalkulacia_produkt__txt_sprac_popl_s_dph",
                              cisloPredmetu: _vm.cisloPredmetu,
                              suffix: "€",
                              textRight: "",
                              "hide-details": "",
                              "hide-label": "",
                              disabled: _vm.isCalculating || !_vm.jeDealer,
                              decimalPlaces: 2,
                              replaceNull: ""
                            },
                            on: {
                              valueChanged: _vm.spracPoplSDphValueChanged,
                              dataLoaded: function($event) {
                                return _vm.visiblePoplatkyHeader(
                                  "sprac_popl",
                                  "s_dph"
                                )
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.ukonPoplVisible,
                          expression: "ukonPoplVisible"
                        }
                      ],
                      staticClass:
                        "poplatok-row-dark poplatok-row px-12px mx-0px",
                      attrs: { "no-gutters": "" }
                    },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "pl-0px",
                          attrs: { xl: "6", lg: "6", md: "6" }
                        },
                        [
                          _c("span", { staticClass: "f16" }, [
                            _vm._v(_vm._s(_vm.ukon_popl.nazov))
                          ])
                        ]
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "px-11px",
                          attrs: { xl: "2", lg: "2", md: "2" }
                        },
                        [
                          _c("numeric-text-box", {
                            key:
                              "liw_filip__wiz_kalkulacia_produkt__txt_ukon_popl_perc" +
                              _vm.cisloPlz,
                            ref: "ukon_popl_perc",
                            attrs: {
                              dense: "",
                              dynamic: "",
                              parentReloaded: _vm.produktFormReloaded,
                              cisloPlz: _vm.cisloPlz,
                              dataId:
                                "liw_filip__wiz_kalkulacia_produkt__txt_ukon_popl_perc",
                              cisloPredmetu: _vm.cisloPredmetu,
                              suffix: "%",
                              textRight: "",
                              "hide-details": "",
                              "hide-label": "",
                              disabled: _vm.isCalculating,
                              decimalPlaces: 3,
                              replaceNull: ""
                            },
                            on: {
                              valueChanged: _vm.ukonPoplPercValueChanged,
                              dataLoaded: function($event) {
                                return _vm.visiblePoplatkyHeader(
                                  "ukon_popl",
                                  "perc"
                                )
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "px-11px",
                          attrs: { xl: "2", lg: "2", md: "2" }
                        },
                        [
                          _c("numeric-text-box", {
                            key:
                              "liw_filip__wiz_kalkulacia_produkt__txt_ukon_popl_zakl" +
                              _vm.cisloPlz,
                            ref: "ukon_popl_zakl",
                            attrs: {
                              dense: "",
                              dynamic: "",
                              parentReloaded: _vm.produktFormReloaded,
                              cisloPlz: _vm.cisloPlz,
                              dataId:
                                "liw_filip__wiz_kalkulacia_produkt__txt_ukon_popl_zakl",
                              cisloPredmetu: _vm.cisloPredmetu,
                              suffix: "€",
                              textRight: "",
                              "hide-details": "",
                              "hide-label": "",
                              disabled: _vm.isCalculating || !_vm.jeDealer,
                              decimalPlaces: 2,
                              replaceNull: ""
                            },
                            on: {
                              valueChanged: _vm.ukonPoplZaklValueChanged,
                              dataLoaded: function($event) {
                                return _vm.visiblePoplatkyHeader(
                                  "ukon_popl",
                                  "zakl"
                                )
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "px-11px",
                          attrs: { xl: "2", lg: "2", md: "2" }
                        },
                        [
                          _c("numeric-text-box", {
                            key:
                              "liw_filip__wiz_kalkulacia_produkt__txt_ukon_popl_s_dph" +
                              _vm.cisloPlz,
                            ref: "ukon_popl_s_dph",
                            attrs: {
                              dense: "",
                              dynamic: "",
                              parentReloaded: _vm.produktFormReloaded,
                              cisloPlz: _vm.cisloPlz,
                              dataId:
                                "liw_filip__wiz_kalkulacia_produkt__txt_ukon_popl_s_dph",
                              cisloPredmetu: _vm.cisloPredmetu,
                              suffix: "€",
                              textRight: "",
                              "hide-details": "",
                              "hide-label": "",
                              disabled: _vm.isCalculating || !_vm.jeDealer,
                              decimalPlaces: 2,
                              replaceNull: ""
                            },
                            on: {
                              valueChanged: _vm.ukonPoplSDphValueChanged,
                              dataLoaded: function($event) {
                                return _vm.visiblePoplatkyHeader(
                                  "ukon_popl",
                                  "s_dph"
                                )
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zvSplKoniecVisible,
                          expression: "zvSplKoniecVisible"
                        }
                      ],
                      staticClass: "poplatok-row px-12px mx-0px",
                      attrs: { "no-gutters": "" }
                    },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "pl-0px",
                          attrs: { xl: "6", lg: "6", md: "6" }
                        },
                        [
                          _c("span", { staticClass: "f16" }, [
                            _vm._v(_vm._s(_vm.zv_spl_koniec.nazov))
                          ])
                        ]
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "px-11px",
                          attrs: { xl: "2", lg: "2", md: "2" }
                        },
                        [
                          _c("numeric-text-box", {
                            key:
                              "liw_filip__wiz_kalkulacia_produkt__txt_zv_spl_koniec_perc" +
                              _vm.cisloPlz,
                            ref: "zv_spl_koniec_perc",
                            attrs: {
                              dense: "",
                              dynamic: "",
                              parentReloaded: _vm.produktFormReloaded,
                              cisloPlz: _vm.cisloPlz,
                              dataId:
                                "liw_filip__wiz_kalkulacia_produkt__txt_zv_spl_koniec_perc",
                              cisloPredmetu: _vm.cisloPredmetu,
                              suffix: "%",
                              textRight: "",
                              "hide-details": "",
                              "hide-label": "",
                              disabled: _vm.isCalculating,
                              decimalPlaces: 3,
                              replaceNull: ""
                            },
                            on: {
                              valueChanged: _vm.zvSplKoniecPercValueChanged,
                              dataLoaded: function($event) {
                                return _vm.visiblePoplatkyHeader(
                                  "zv_spl_koniec",
                                  "perc"
                                )
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "px-11px",
                          attrs: { xl: "2", lg: "2", md: "2" }
                        },
                        [
                          _c("numeric-text-box", {
                            key:
                              "liw_filip__wiz_kalkulacia_produkt__txt_zv_spl_koniec_zakl" +
                              _vm.cisloPlz,
                            ref: "zv_spl_koniec_zakl",
                            attrs: {
                              dense: "",
                              dynamic: "",
                              parentReloaded: _vm.produktFormReloaded,
                              cisloPlz: _vm.cisloPlz,
                              dataId:
                                "liw_filip__wiz_kalkulacia_produkt__txt_zv_spl_koniec_zakl",
                              cisloPredmetu: _vm.cisloPredmetu,
                              suffix: "€",
                              textRight: "",
                              "hide-details": "",
                              "hide-label": "",
                              disabled: _vm.isCalculating || !_vm.jeDealer,
                              decimalPlaces: 2,
                              replaceNull: ""
                            },
                            on: {
                              valueChanged: _vm.zvSplKoniecZaklValueChanged,
                              dataLoaded: function($event) {
                                return _vm.visiblePoplatkyHeader(
                                  "zv_spl_koniec",
                                  "zakl"
                                )
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "px-11px",
                          attrs: { xl: "2", lg: "2", md: "2" }
                        },
                        [
                          _c("numeric-text-box", {
                            key:
                              "liw_filip__wiz_kalkulacia_produkt__txt_zv_spl_koniec_s_dph" +
                              _vm.cisloPlz,
                            ref: "zv_spl_koniec_s_dph",
                            attrs: {
                              dense: "",
                              dynamic: "",
                              parentReloaded: _vm.produktFormReloaded,
                              cisloPlz: _vm.cisloPlz,
                              dataId:
                                "liw_filip__wiz_kalkulacia_produkt__txt_zv_spl_koniec_s_dph",
                              cisloPredmetu: _vm.cisloPredmetu,
                              suffix: "€",
                              textRight: "",
                              "hide-details": "",
                              "hide-label": "",
                              disabled: _vm.isCalculating || !_vm.jeDealer,
                              decimalPlaces: 2,
                              replaceNull: ""
                            },
                            on: {
                              valueChanged: _vm.zvSplKoniecSDphValueChanged,
                              dataLoaded: function($event) {
                                return _vm.visiblePoplatkyHeader(
                                  "zv_spl_koniec",
                                  "s_dph"
                                )
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zostHodnVisible,
                          expression: "zostHodnVisible"
                        }
                      ],
                      staticClass: "poplatok-row px-12px mx-0px",
                      attrs: { "no-gutters": "" }
                    },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "pl-0px",
                          attrs: { xl: "6", lg: "6", md: "6" }
                        },
                        [
                          _c("span", { staticClass: "f16" }, [
                            _vm._v(_vm._s(_vm.zost_hodn.nazov))
                          ])
                        ]
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "px-11px",
                          attrs: { xl: "2", lg: "2", md: "2" }
                        },
                        [
                          _c("numeric-text-box", {
                            key:
                              "liw_filip__wiz_kalkulacia_produkt__txt_zost_hodnota_perc" +
                              _vm.cisloPlz,
                            ref: "zost_hodnota_perc",
                            attrs: {
                              dense: "",
                              dynamic: "",
                              parentReloaded: _vm.produktFormReloaded,
                              cisloPlz: _vm.cisloPlz,
                              dataId:
                                "liw_filip__wiz_kalkulacia_produkt__txt_zost_hodnota_perc",
                              cisloPredmetu: _vm.cisloPredmetu,
                              suffix: "%",
                              textRight: "",
                              "hide-details": "",
                              "hide-label": "",
                              disabled: _vm.isCalculating,
                              decimalPlaces: 3,
                              replaceNull: ""
                            },
                            on: {
                              valueChanged: _vm.zostHodnotaPercValueChanged,
                              dataLoaded: function($event) {
                                return _vm.visiblePoplatkyHeader(
                                  "zost_hodnota",
                                  "perc"
                                )
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "px-11px",
                          attrs: { xl: "2", lg: "2", md: "2" }
                        },
                        [
                          _c("numeric-text-box", {
                            key:
                              "liw_filip__wiz_kalkulacia_produkt__txt_zost_hodnota_zakl" +
                              _vm.cisloPlz,
                            ref: "zost_hodnota_zakl",
                            attrs: {
                              dense: "",
                              dynamic: "",
                              parentReloaded: _vm.produktFormReloaded,
                              cisloPlz: _vm.cisloPlz,
                              dataId:
                                "liw_filip__wiz_kalkulacia_produkt__txt_zost_hodnota_zakl",
                              cisloPredmetu: _vm.cisloPredmetu,
                              suffix: "€",
                              textRight: "",
                              "hide-details": "",
                              "hide-label": "",
                              disabled: _vm.isCalculating,
                              decimalPlaces: 2,
                              replaceNull: ""
                            },
                            on: {
                              valueChanged: _vm.zostHodnotaZaklValueChanged,
                              dataLoaded: function($event) {
                                return _vm.visiblePoplatkyHeader(
                                  "zost_hodnota",
                                  "zakl"
                                )
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "px-11px",
                          attrs: { xl: "2", lg: "2", md: "2" }
                        },
                        [
                          _c("numeric-text-box", {
                            key:
                              "liw_filip__wiz_kalkulacia_produkt__txt_zost_hodnota_s_dph" +
                              _vm.cisloPlz,
                            ref: "zost_hodnota_s_dph",
                            attrs: {
                              dense: "",
                              dynamic: "",
                              parentReloaded: _vm.produktFormReloaded,
                              cisloPlz: _vm.cisloPlz,
                              dataId:
                                "liw_filip__wiz_kalkulacia_produkt__txt_zost_hodnota_s_dph",
                              cisloPredmetu: _vm.cisloPredmetu,
                              suffix: "€",
                              textRight: "",
                              "hide-details": "",
                              "hide-label": "",
                              disabled: _vm.isCalculating,
                              decimalPlaces: 2,
                              replaceNull: ""
                            },
                            on: {
                              valueChanged: _vm.zostHodnotaSDphValueChanged,
                              dataLoaded: function($event) {
                                return _vm.visiblePoplatkyHeader(
                                  "zost_hodnota",
                                  "s_dph"
                                )
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              : [
                  _vm.spPoplVisible
                    ? _c(
                        "div",
                        { staticClass: "mobile-poplatok-card mt-4" },
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "pt-4",
                              attrs: { "no-gutters": "" }
                            },
                            [
                              _c("v-col", { attrs: { cols: "12" } }, [
                                _c("span", { staticClass: "f12 gs100" }, [
                                  _vm._v("Názov poplatku")
                                ])
                              ]),
                              _c("v-col", { attrs: { cols: "12" } }, [
                                _c("span", { staticClass: "f16 bold" }, [
                                  _vm._v(_vm._s(_vm.sp_popl.nazov))
                                ])
                              ])
                            ],
                            1
                          ),
                          _c(
                            "v-row",
                            {
                              staticClass: "pt-4",
                              attrs: { "no-gutters": "" }
                            },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "pb-4",
                                  attrs: {
                                    cols:
                                      _vm.isControlDisabled(
                                        "sprac_popl_perc",
                                        "liw_filip__wiz_kalkulacia_produkt__txt_sprac_popl_perc"
                                      ) && _vm.$refs.sprac_popl_perc.l_visible
                                        ? 6
                                        : 12
                                  }
                                },
                                [
                                  _vm.isControlDisabled(
                                    "sprac_popl_perc",
                                    "liw_filip__wiz_kalkulacia_produkt__txt_sprac_popl_perc"
                                  ) && _vm.$refs.sprac_popl_perc.l_visible
                                    ? [
                                        _c(
                                          "v-row",
                                          { attrs: { "no-gutters": "" } },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "f12 gs100" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$refs.sprac_popl_perc
                                                      .getLabel
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _c(
                                          "v-row",
                                          {
                                            staticClass: "bold",
                                            attrs: { "no-gutters": "" }
                                          },
                                          [
                                            _c("span", { staticClass: "f16" }, [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$refs.sprac_popl_perc
                                                    .stringValue +
                                                    " " +
                                                    _vm.$refs.sprac_popl_perc
                                                      .suffix
                                                ) + " "
                                              )
                                            ])
                                          ]
                                        )
                                      ]
                                    : _vm._e(),
                                  _c("numeric-text-box", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.isReversedControlDisabled(
                                          "sprac_popl_perc",
                                          "liw_filip__wiz_kalkulacia_produkt__txt_sprac_popl_perc"
                                        ),
                                        expression:
                                          "isReversedControlDisabled('sprac_popl_perc','liw_filip__wiz_kalkulacia_produkt__txt_sprac_popl_perc')"
                                      }
                                    ],
                                    key:
                                      "liw_filip__wiz_kalkulacia_produkt__txt_sprac_popl_perc" +
                                      _vm.cisloPlz,
                                    ref: "sprac_popl_perc",
                                    attrs: {
                                      dynamic: "",
                                      parentReloaded: _vm.produktFormReloaded,
                                      cisloPlz: _vm.cisloPlz,
                                      dataId:
                                        "liw_filip__wiz_kalkulacia_produkt__txt_sprac_popl_perc",
                                      cisloPredmetu: _vm.cisloPredmetu,
                                      suffix: "%",
                                      "hide-details": "",
                                      customLabel: "Výška v %",
                                      disabled: _vm.isCalculating,
                                      decimalPlaces: 3,
                                      replaceNull: ""
                                    },
                                    on: {
                                      valueChanged:
                                        _vm.spracPoplPercValueChanged,
                                      dataLoaded: function($event) {
                                        return _vm.visiblePoplatkyHeader(
                                          "sprac_popl",
                                          "perc"
                                        )
                                      }
                                    }
                                  })
                                ],
                                2
                              ),
                              _c(
                                "v-col",
                                {
                                  staticClass: "pb-4",
                                  attrs: {
                                    cols:
                                      _vm.isControlDisabled(
                                        "sprac_popl_zakl",
                                        "liw_filip__wiz_kalkulacia_produkt__txt_sprac_popl_zakl"
                                      ) && _vm.$refs.sprac_popl_zakl.l_visible
                                        ? 6
                                        : 12
                                  }
                                },
                                [
                                  _vm.isControlDisabled(
                                    "sprac_popl_zakl",
                                    "liw_filip__wiz_kalkulacia_produkt__txt_sprac_popl_zakl"
                                  ) && _vm.$refs.sprac_popl_zakl.l_visible
                                    ? [
                                        _c(
                                          "v-row",
                                          { attrs: { "no-gutters": "" } },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "f12 gs100" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$refs.sprac_popl_zakl
                                                      .getLabel
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _c(
                                          "v-row",
                                          {
                                            staticClass: "bold",
                                            attrs: { "no-gutters": "" }
                                          },
                                          [
                                            _c("span", { staticClass: "f16" }, [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$refs.sprac_popl_zakl
                                                    .stringValue +
                                                    " " +
                                                    _vm.$refs.sprac_popl_zakl
                                                      .suffix
                                                ) + " "
                                              )
                                            ])
                                          ]
                                        )
                                      ]
                                    : _vm._e(),
                                  _c("numeric-text-box", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.isReversedControlDisabled(
                                          "sprac_popl_zakl",
                                          "liw_filip__wiz_kalkulacia_produkt__txt_sprac_popl_zakl"
                                        ),
                                        expression:
                                          "isReversedControlDisabled('sprac_popl_zakl','liw_filip__wiz_kalkulacia_produkt__txt_sprac_popl_zakl')"
                                      }
                                    ],
                                    key:
                                      "liw_filip__wiz_kalkulacia_produkt__txt_sprac_popl_zakl" +
                                      _vm.cisloPlz,
                                    ref: "sprac_popl_zakl",
                                    attrs: {
                                      dynamic: "",
                                      parentReloaded: _vm.produktFormReloaded,
                                      cisloPlz: _vm.cisloPlz,
                                      dataId:
                                        "liw_filip__wiz_kalkulacia_produkt__txt_sprac_popl_zakl",
                                      cisloPredmetu: _vm.cisloPredmetu,
                                      suffix: "€",
                                      "hide-details": "",
                                      customLabel: "Základ",
                                      disabled:
                                        _vm.isCalculating || !_vm.jeDealer,
                                      decimalPlaces: 2,
                                      replaceNull: ""
                                    },
                                    on: {
                                      valueChanged:
                                        _vm.spracPoplZaklValueChanged,
                                      dataLoaded: function($event) {
                                        return _vm.visiblePoplatkyHeader(
                                          "sprac_popl",
                                          "zakl"
                                        )
                                      }
                                    }
                                  })
                                ],
                                2
                              ),
                              _c(
                                "v-col",
                                {
                                  staticClass: "pb-4",
                                  attrs: {
                                    cols:
                                      _vm.isControlDisabled(
                                        "sprac_popl_s_dph",
                                        "liw_filip__wiz_kalkulacia_produkt__txt_sprac_popl_s_dph"
                                      ) && _vm.$refs.sprac_popl_s_dph.l_visible
                                        ? 6
                                        : 12
                                  }
                                },
                                [
                                  _vm.isControlDisabled(
                                    "sprac_popl_s_dph",
                                    "liw_filip__wiz_kalkulacia_produkt__txt_sprac_popl_s_dph"
                                  ) && _vm.$refs.sprac_popl_s_dph.l_visible
                                    ? [
                                        _c(
                                          "v-row",
                                          { attrs: { "no-gutters": "" } },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "f12 gs100" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$refs.sprac_popl_s_dph
                                                      .getLabel
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _c(
                                          "v-row",
                                          {
                                            staticClass: "bold",
                                            attrs: { "no-gutters": "" }
                                          },
                                          [
                                            _c("span", { staticClass: "f16" }, [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$refs.sprac_popl_s_dph
                                                    .stringValue +
                                                    " " +
                                                    _vm.$refs.sprac_popl_s_dph
                                                      .suffix
                                                ) + " "
                                              )
                                            ])
                                          ]
                                        )
                                      ]
                                    : _vm._e(),
                                  _c("numeric-text-box", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.isReversedControlDisabled(
                                          "sprac_popl_s_dph",
                                          "liw_filip__wiz_kalkulacia_produkt__txt_sprac_popl_s_dph"
                                        ),
                                        expression:
                                          "isReversedControlDisabled('sprac_popl_s_dph','liw_filip__wiz_kalkulacia_produkt__txt_sprac_popl_s_dph')"
                                      }
                                    ],
                                    key:
                                      "liw_filip__wiz_kalkulacia_produkt__txt_sprac_popl_s_dph" +
                                      _vm.cisloPlz,
                                    ref: "sprac_popl_s_dph",
                                    attrs: {
                                      dynamic: "",
                                      parentReloaded: _vm.produktFormReloaded,
                                      cisloPlz: _vm.cisloPlz,
                                      dataId:
                                        "liw_filip__wiz_kalkulacia_produkt__txt_sprac_popl_s_dph",
                                      cisloPredmetu: _vm.cisloPredmetu,
                                      suffix: "€",
                                      "hide-details": "",
                                      customLabel: _vm.jeDealer
                                        ? "Spolu"
                                        : "Cena s DPH",
                                      disabled:
                                        _vm.isCalculating || !_vm.jeDealer,
                                      decimalPlaces: 2,
                                      replaceNull: ""
                                    },
                                    on: {
                                      valueChanged:
                                        _vm.spracPoplSDphValueChanged,
                                      dataLoaded: function($event) {
                                        return _vm.visiblePoplatkyHeader(
                                          "sprac_popl",
                                          "s_dph"
                                        )
                                      }
                                    }
                                  })
                                ],
                                2
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.ukonPoplVisible
                    ? _c(
                        "div",
                        { staticClass: "mobile-poplatok-card mt-4" },
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "pt-4",
                              attrs: { "no-gutters": "" }
                            },
                            [
                              _c("v-col", { attrs: { cols: "12" } }, [
                                _c("span", { staticClass: "f12 gs100" }, [
                                  _vm._v("Názov poplatku")
                                ])
                              ]),
                              _c("v-col", { attrs: { cols: "12" } }, [
                                _c("span", { staticClass: "f16 bold" }, [
                                  _vm._v(_vm._s(_vm.ukon_popl.nazov))
                                ])
                              ])
                            ],
                            1
                          ),
                          _c(
                            "v-row",
                            {
                              staticClass: "pt-4",
                              attrs: { "no-gutters": "" }
                            },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "pb-4",
                                  attrs: {
                                    cols:
                                      _vm.isControlDisabled(
                                        "ukon_popl_perc",
                                        "liw_filip__wiz_kalkulacia_produkt__txt_ukon_popl_perc"
                                      ) && _vm.$refs.ukon_popl_perc.l_visible
                                        ? 6
                                        : 12
                                  }
                                },
                                [
                                  _vm.isControlDisabled(
                                    "ukon_popl_perc",
                                    "liw_filip__wiz_kalkulacia_produkt__txt_ukon_popl_perc"
                                  ) && _vm.$refs.ukon_popl_perc.l_visible
                                    ? [
                                        _c(
                                          "v-row",
                                          { attrs: { "no-gutters": "" } },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "f12 gs100" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$refs.ukon_popl_perc
                                                      .getLabel
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _c(
                                          "v-row",
                                          {
                                            staticClass: "bold",
                                            attrs: { "no-gutters": "" }
                                          },
                                          [
                                            _c("span", { staticClass: "f16" }, [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$refs.ukon_popl_perc
                                                    .stringValue +
                                                    " " +
                                                    _vm.$refs.ukon_popl_perc
                                                      .suffix
                                                ) + " "
                                              )
                                            ])
                                          ]
                                        )
                                      ]
                                    : _vm._e(),
                                  _c("numeric-text-box", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.isReversedControlDisabled(
                                          "ukon_popl_perc",
                                          "liw_filip__wiz_kalkulacia_produkt__txt_ukon_popl_perc"
                                        ),
                                        expression:
                                          "isReversedControlDisabled('ukon_popl_perc','liw_filip__wiz_kalkulacia_produkt__txt_ukon_popl_perc')"
                                      }
                                    ],
                                    key:
                                      "liw_filip__wiz_kalkulacia_produkt__txt_ukon_popl_perc" +
                                      _vm.cisloPlz,
                                    ref: "ukon_popl_perc",
                                    attrs: {
                                      dynamic: "",
                                      parentReloaded: _vm.produktFormReloaded,
                                      cisloPlz: _vm.cisloPlz,
                                      dataId:
                                        "liw_filip__wiz_kalkulacia_produkt__txt_ukon_popl_perc",
                                      cisloPredmetu: _vm.cisloPredmetu,
                                      suffix: "%",
                                      "hide-details": "",
                                      customLabel: "Výška v %",
                                      disabled: _vm.isCalculating,
                                      decimalPlaces: 3,
                                      replaceNull: ""
                                    },
                                    on: {
                                      valueChanged:
                                        _vm.ukonPoplPercValueChanged,
                                      dataLoaded: function($event) {
                                        return _vm.visiblePoplatkyHeader(
                                          "ukon_popl",
                                          "perc"
                                        )
                                      }
                                    }
                                  })
                                ],
                                2
                              ),
                              _c(
                                "v-col",
                                {
                                  staticClass: "pb-4",
                                  attrs: {
                                    cols:
                                      _vm.isControlDisabled(
                                        "ukon_popl_zakl",
                                        "liw_filip__wiz_kalkulacia_produkt__txt_ukon_popl_zakl"
                                      ) && _vm.$refs.ukon_popl_zakl.l_visible
                                        ? 6
                                        : 12
                                  }
                                },
                                [
                                  _vm.isControlDisabled(
                                    "ukon_popl_zakl",
                                    "liw_filip__wiz_kalkulacia_produkt__txt_ukon_popl_zakl"
                                  ) && _vm.$refs.ukon_popl_zakl.l_visible
                                    ? [
                                        _c(
                                          "v-row",
                                          { attrs: { "no-gutters": "" } },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "f12 gs100" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$refs.ukon_popl_zakl
                                                      .getLabel
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _c(
                                          "v-row",
                                          {
                                            staticClass: "bold",
                                            attrs: { "no-gutters": "" }
                                          },
                                          [
                                            _c("span", { staticClass: "f16" }, [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$refs.ukon_popl_zakl
                                                    .stringValue +
                                                    " " +
                                                    _vm.$refs.ukon_popl_zakl
                                                      .suffix
                                                ) + " "
                                              )
                                            ])
                                          ]
                                        )
                                      ]
                                    : _vm._e(),
                                  _c("numeric-text-box", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.isReversedControlDisabled(
                                          "ukon_popl_zakl",
                                          "liw_filip__wiz_kalkulacia_produkt__txt_ukon_popl_zakl"
                                        ),
                                        expression:
                                          "isReversedControlDisabled('ukon_popl_zakl','liw_filip__wiz_kalkulacia_produkt__txt_ukon_popl_zakl')"
                                      }
                                    ],
                                    key:
                                      "liw_filip__wiz_kalkulacia_produkt__txt_ukon_popl_zakl" +
                                      _vm.cisloPlz,
                                    ref: "ukon_popl_zakl",
                                    attrs: {
                                      dynamic: "",
                                      parentReloaded: _vm.produktFormReloaded,
                                      cisloPlz: _vm.cisloPlz,
                                      dataId:
                                        "liw_filip__wiz_kalkulacia_produkt__txt_ukon_popl_zakl",
                                      cisloPredmetu: _vm.cisloPredmetu,
                                      suffix: "€",
                                      "hide-details": "",
                                      customLabel: "Základ",
                                      disabled:
                                        _vm.isCalculating || !_vm.jeDealer,
                                      decimalPlaces: 2,
                                      replaceNull: ""
                                    },
                                    on: {
                                      valueChanged:
                                        _vm.ukonPoplZaklValueChanged,
                                      dataLoaded: function($event) {
                                        return _vm.visiblePoplatkyHeader(
                                          "ukon_popl",
                                          "zakl"
                                        )
                                      }
                                    }
                                  })
                                ],
                                2
                              ),
                              _c(
                                "v-col",
                                {
                                  staticClass: "pb-4",
                                  attrs: {
                                    cols:
                                      _vm.isControlDisabled(
                                        "ukon_popl_s_dph",
                                        "liw_filip__wiz_kalkulacia_produkt__txt_ukon_popl_s_dph"
                                      ) && _vm.$refs.ukon_popl_s_dph.l_visible
                                        ? 6
                                        : 12
                                  }
                                },
                                [
                                  _vm.isControlDisabled(
                                    "ukon_popl_s_dph",
                                    "liw_filip__wiz_kalkulacia_produkt__txt_ukon_popl_s_dph"
                                  ) && _vm.$refs.ukon_popl_s_dph.l_visible
                                    ? [
                                        _c(
                                          "v-row",
                                          { attrs: { "no-gutters": "" } },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "f12 gs100" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$refs.ukon_popl_s_dph
                                                      .getLabel
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _c(
                                          "v-row",
                                          {
                                            staticClass: "bold",
                                            attrs: { "no-gutters": "" }
                                          },
                                          [
                                            _c("span", { staticClass: "f16" }, [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$refs.ukon_popl_s_dph
                                                    .stringValue +
                                                    " " +
                                                    _vm.$refs.ukon_popl_s_dph
                                                      .suffix
                                                ) + " "
                                              )
                                            ])
                                          ]
                                        )
                                      ]
                                    : _vm._e(),
                                  _c("numeric-text-box", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.isReversedControlDisabled(
                                          "ukon_popl_s_dph",
                                          "liw_filip__wiz_kalkulacia_produkt__txt_ukon_popl_s_dph"
                                        ),
                                        expression:
                                          "isReversedControlDisabled('ukon_popl_s_dph','liw_filip__wiz_kalkulacia_produkt__txt_ukon_popl_s_dph')"
                                      }
                                    ],
                                    key:
                                      "liw_filip__wiz_kalkulacia_produkt__txt_ukon_popl_s_dph" +
                                      _vm.cisloPlz,
                                    ref: "ukon_popl_s_dph",
                                    attrs: {
                                      dynamic: "",
                                      parentReloaded: _vm.produktFormReloaded,
                                      cisloPlz: _vm.cisloPlz,
                                      dataId:
                                        "liw_filip__wiz_kalkulacia_produkt__txt_ukon_popl_s_dph",
                                      cisloPredmetu: _vm.cisloPredmetu,
                                      suffix: "€",
                                      "hide-details": "",
                                      customLabel: _vm.jeDealer
                                        ? "Spolu"
                                        : "Cena s DPH",
                                      disabled:
                                        _vm.isCalculating || !_vm.jeDealer,
                                      decimalPlaces: 2,
                                      replaceNull: ""
                                    },
                                    on: {
                                      valueChanged:
                                        _vm.ukonPoplSDphValueChanged,
                                      dataLoaded: function($event) {
                                        return _vm.visiblePoplatkyHeader(
                                          "ukon_popl",
                                          "s_dph"
                                        )
                                      }
                                    }
                                  })
                                ],
                                2
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.zvSplKoniecVisible
                    ? _c(
                        "div",
                        { staticClass: "mobile-poplatok-card mt-4" },
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "pt-4",
                              attrs: { "no-gutters": "" }
                            },
                            [
                              _c("v-col", { attrs: { cols: "12" } }, [
                                _c("span", { staticClass: "f12 gs100" }, [
                                  _vm._v("Názov poplatku")
                                ])
                              ]),
                              _c("v-col", { attrs: { cols: "12" } }, [
                                _c("span", { staticClass: "f16 bold" }, [
                                  _vm._v(_vm._s(_vm.zv_spl_koniec.nazov))
                                ])
                              ])
                            ],
                            1
                          ),
                          _c(
                            "v-row",
                            {
                              staticClass: "pt-4",
                              attrs: { "no-gutters": "" }
                            },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "pb-4",
                                  attrs: {
                                    cols:
                                      _vm.isControlDisabled(
                                        "zv_spl_koniec_perc",
                                        "liw_filip__wiz_kalkulacia_produkt__txt_zv_spl_koniec_perc"
                                      ) &&
                                      _vm.$refs.zv_spl_koniec_perc.l_visible
                                        ? 6
                                        : 12
                                  }
                                },
                                [
                                  _vm.isControlDisabled(
                                    "zv_spl_koniec_perc",
                                    "liw_filip__wiz_kalkulacia_produkt__txt_zv_spl_koniec_perc"
                                  ) && _vm.$refs.zv_spl_koniec_perc.l_visible
                                    ? [
                                        _c(
                                          "v-row",
                                          { attrs: { "no-gutters": "" } },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "f12 gs100" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$refs.zv_spl_koniec_perc
                                                      .getLabel
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _c(
                                          "v-row",
                                          {
                                            staticClass: "bold",
                                            attrs: { "no-gutters": "" }
                                          },
                                          [
                                            _c("span", { staticClass: "f16" }, [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$refs.zv_spl_koniec_perc
                                                    .stringValue +
                                                    " " +
                                                    _vm.$refs.zv_spl_koniec_perc
                                                      .suffix
                                                ) + " "
                                              )
                                            ])
                                          ]
                                        )
                                      ]
                                    : _vm._e(),
                                  _c("numeric-text-box", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.isReversedControlDisabled(
                                          "zv_spl_koniec_perc",
                                          "liw_filip__wiz_kalkulacia_produkt__txt_zv_spl_koniec_perc"
                                        ),
                                        expression:
                                          "isReversedControlDisabled('zv_spl_koniec_perc','liw_filip__wiz_kalkulacia_produkt__txt_zv_spl_koniec_perc')"
                                      }
                                    ],
                                    key:
                                      "liw_filip__wiz_kalkulacia_produkt__txt_zv_spl_koniec_perc" +
                                      _vm.cisloPlz,
                                    ref: "zv_spl_koniec_perc",
                                    attrs: {
                                      dynamic: "",
                                      parentReloaded: _vm.produktFormReloaded,
                                      cisloPlz: _vm.cisloPlz,
                                      dataId:
                                        "liw_filip__wiz_kalkulacia_produkt__txt_zv_spl_koniec_perc",
                                      cisloPredmetu: _vm.cisloPredmetu,
                                      suffix: "%",
                                      "hide-details": "",
                                      customLabel: "Výška v %",
                                      disabled: _vm.isCalculating,
                                      decimalPlaces: 3,
                                      replaceNull: ""
                                    },
                                    on: {
                                      valueChanged:
                                        _vm.zvSplKoniecPercValueChanged,
                                      dataLoaded: function($event) {
                                        return _vm.visiblePoplatkyHeader(
                                          "zv_spl_koniec",
                                          "perc"
                                        )
                                      }
                                    }
                                  })
                                ],
                                2
                              ),
                              _c(
                                "v-col",
                                {
                                  staticClass: "pb-4",
                                  attrs: {
                                    cols:
                                      _vm.isControlDisabled(
                                        "zv_spl_koniec_zakl",
                                        "liw_filip__wiz_kalkulacia_produkt__txt_zv_spl_koniec_zakl"
                                      ) &&
                                      _vm.$refs.zv_spl_koniec_zakl.l_visible
                                        ? 6
                                        : 12
                                  }
                                },
                                [
                                  _vm.isControlDisabled(
                                    "zv_spl_koniec_zakl",
                                    "liw_filip__wiz_kalkulacia_produkt__txt_zv_spl_koniec_zakl"
                                  ) && _vm.$refs.zv_spl_koniec_zakl.l_visible
                                    ? [
                                        _c(
                                          "v-row",
                                          { attrs: { "no-gutters": "" } },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "f12 gs100" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$refs.zv_spl_koniec_zakl
                                                      .getLabel
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _c(
                                          "v-row",
                                          {
                                            staticClass: "bold",
                                            attrs: { "no-gutters": "" }
                                          },
                                          [
                                            _c("span", { staticClass: "f16" }, [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$refs.zv_spl_koniec_zakl
                                                    .stringValue +
                                                    " " +
                                                    _vm.$refs.zv_spl_koniec_zakl
                                                      .suffix
                                                ) + " "
                                              )
                                            ])
                                          ]
                                        )
                                      ]
                                    : _vm._e(),
                                  _c("numeric-text-box", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.isReversedControlDisabled(
                                          "zv_spl_koniec_zakl",
                                          "liw_filip__wiz_kalkulacia_produkt__txt_zv_spl_koniec_zakl"
                                        ),
                                        expression:
                                          "isReversedControlDisabled('zv_spl_koniec_zakl','liw_filip__wiz_kalkulacia_produkt__txt_zv_spl_koniec_zakl')"
                                      }
                                    ],
                                    key:
                                      "liw_filip__wiz_kalkulacia_produkt__txt_zv_spl_koniec_zakl" +
                                      _vm.cisloPlz,
                                    ref: "zv_spl_koniec_zakl",
                                    attrs: {
                                      dynamic: "",
                                      parentReloaded: _vm.produktFormReloaded,
                                      cisloPlz: _vm.cisloPlz,
                                      dataId:
                                        "liw_filip__wiz_kalkulacia_produkt__txt_zv_spl_koniec_zakl",
                                      cisloPredmetu: _vm.cisloPredmetu,
                                      suffix: "€",
                                      "hide-details": "",
                                      customLabel: "Základ",
                                      disabled:
                                        _vm.isCalculating || !_vm.jeDealer,
                                      decimalPlaces: 2,
                                      replaceNull: ""
                                    },
                                    on: {
                                      valueChanged:
                                        _vm.zvSplKoniecZaklValueChanged,
                                      dataLoaded: function($event) {
                                        return _vm.visiblePoplatkyHeader(
                                          "zv_spl_koniec",
                                          "zakl"
                                        )
                                      }
                                    }
                                  })
                                ],
                                2
                              ),
                              _c(
                                "v-col",
                                {
                                  staticClass: "pb-4",
                                  attrs: {
                                    cols:
                                      _vm.isControlDisabled(
                                        "zv_spl_koniec_s_dph",
                                        "liw_filip__wiz_kalkulacia_produkt__txt_zv_spl_koniec_s_dph"
                                      ) &&
                                      _vm.$refs.zv_spl_koniec_s_dph.l_visible
                                        ? 6
                                        : 12
                                  }
                                },
                                [
                                  _vm.isControlDisabled(
                                    "zv_spl_koniec_s_dph",
                                    "liw_filip__wiz_kalkulacia_produkt__txt_zv_spl_koniec_s_dph"
                                  ) && _vm.$refs.zv_spl_koniec_s_dph.l_visible
                                    ? [
                                        _c(
                                          "v-row",
                                          { attrs: { "no-gutters": "" } },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "f12 gs100" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$refs
                                                      .zv_spl_koniec_s_dph
                                                      .getLabel
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _c(
                                          "v-row",
                                          {
                                            staticClass: "bold",
                                            attrs: { "no-gutters": "" }
                                          },
                                          [
                                            _c("span", { staticClass: "f16" }, [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$refs.zv_spl_koniec_s_dph
                                                    .stringValue +
                                                    " " +
                                                    _vm.$refs
                                                      .zv_spl_koniec_s_dph
                                                      .suffix
                                                ) + " "
                                              )
                                            ])
                                          ]
                                        )
                                      ]
                                    : _vm._e(),
                                  _c("numeric-text-box", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.isReversedControlDisabled(
                                          "zv_spl_koniec_s_dph",
                                          "liw_filip__wiz_kalkulacia_produkt__txt_zv_spl_koniec_s_dph"
                                        ),
                                        expression:
                                          "isReversedControlDisabled('zv_spl_koniec_s_dph','liw_filip__wiz_kalkulacia_produkt__txt_zv_spl_koniec_s_dph')"
                                      }
                                    ],
                                    key:
                                      "liw_filip__wiz_kalkulacia_produkt__txt_zv_spl_koniec_s_dph" +
                                      _vm.cisloPlz,
                                    ref: "zv_spl_koniec_s_dph",
                                    attrs: {
                                      dynamic: "",
                                      parentReloaded: _vm.produktFormReloaded,
                                      cisloPlz: _vm.cisloPlz,
                                      dataId:
                                        "liw_filip__wiz_kalkulacia_produkt__txt_zv_spl_koniec_s_dph",
                                      cisloPredmetu: _vm.cisloPredmetu,
                                      suffix: "€",
                                      customLabel: _vm.jeDealer
                                        ? "Spolu"
                                        : "Cena s DPH",
                                      "hide-details": "",
                                      disabled:
                                        _vm.isCalculating || !_vm.jeDealer,
                                      decimalPlaces: 2,
                                      replaceNull: ""
                                    },
                                    on: {
                                      valueChanged:
                                        _vm.zvSplKoniecSDphValueChanged,
                                      dataLoaded: function($event) {
                                        return _vm.visiblePoplatkyHeader(
                                          "zv_spl_koniec",
                                          "s_dph"
                                        )
                                      }
                                    }
                                  })
                                ],
                                2
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.zostHodnVisible
                    ? _c(
                        "div",
                        { staticClass: "mobile-poplatok-card mt-4" },
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "pt-4",
                              attrs: { "no-gutters": "" }
                            },
                            [
                              _c("v-col", { attrs: { cols: "12" } }, [
                                _c("span", { staticClass: "f12 gs100" }, [
                                  _vm._v("Názov poplatku")
                                ])
                              ]),
                              _c("v-col", { attrs: { cols: "12" } }, [
                                _c("span", { staticClass: "f16 bold" }, [
                                  _vm._v(_vm._s(_vm.zost_hodn.nazov))
                                ])
                              ])
                            ],
                            1
                          ),
                          _c(
                            "v-row",
                            {
                              staticClass: "pt-4",
                              attrs: { "no-gutters": "" }
                            },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "pb-4",
                                  attrs: {
                                    cols:
                                      _vm.isControlDisabled(
                                        "zost_hodnota_perc",
                                        "liw_filip__wiz_kalkulacia_produkt__txt_zost_hodnota_perc"
                                      ) && _vm.$refs.zost_hodnota_perc.l_visible
                                        ? 6
                                        : 12
                                  }
                                },
                                [
                                  _vm.isControlDisabled(
                                    "zost_hodnota_perc",
                                    "liw_filip__wiz_kalkulacia_produkt__txt_zost_hodnota_perc"
                                  ) && _vm.$refs.zost_hodnota_perc.l_visible
                                    ? [
                                        _c(
                                          "v-row",
                                          { attrs: { "no-gutters": "" } },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "f12 gs100" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$refs.zost_hodnota_perc
                                                      .getLabel
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _c(
                                          "v-row",
                                          {
                                            staticClass: "bold",
                                            attrs: { "no-gutters": "" }
                                          },
                                          [
                                            _c("span", { staticClass: "f16" }, [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$refs.zost_hodnota_perc
                                                    .stringValue +
                                                    " " +
                                                    _vm.$refs.zost_hodnota_perc
                                                      .suffix
                                                ) + " "
                                              )
                                            ])
                                          ]
                                        )
                                      ]
                                    : _vm._e(),
                                  _c("numeric-text-box", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.isReversedControlDisabled(
                                          "zost_hodnota_perc",
                                          "liw_filip__wiz_kalkulacia_produkt__txt_zost_hodnota_perc"
                                        ),
                                        expression:
                                          "isReversedControlDisabled('zost_hodnota_perc','liw_filip__wiz_kalkulacia_produkt__txt_zost_hodnota_perc')"
                                      }
                                    ],
                                    key:
                                      "liw_filip__wiz_kalkulacia_produkt__txt_zost_hodnota_perc" +
                                      _vm.cisloPlz,
                                    ref: "zost_hodnota_perc",
                                    attrs: {
                                      dynamic: "",
                                      parentReloaded: _vm.produktFormReloaded,
                                      cisloPlz: _vm.cisloPlz,
                                      dataId:
                                        "liw_filip__wiz_kalkulacia_produkt__txt_zost_hodnota_perc",
                                      cisloPredmetu: _vm.cisloPredmetu,
                                      suffix: "%",
                                      "hide-details": "",
                                      customLabel: "Výška v %",
                                      disabled: _vm.isCalculating,
                                      decimalPlaces: 3,
                                      replaceNull: ""
                                    },
                                    on: {
                                      valueChanged:
                                        _vm.zostHodnotaPercValueChanged,
                                      dataLoaded: function($event) {
                                        return _vm.visiblePoplatkyHeader(
                                          "zost_hodnota",
                                          "perc"
                                        )
                                      }
                                    }
                                  })
                                ],
                                2
                              ),
                              _c(
                                "v-col",
                                {
                                  staticClass: "pb-4",
                                  attrs: {
                                    cols:
                                      _vm.isControlDisabled(
                                        "zost_hodnota_zakl",
                                        "liw_filip__wiz_kalkulacia_produkt__txt_zost_hodnota_zakl"
                                      ) && _vm.$refs.zost_hodnota_zakl.l_visible
                                        ? 6
                                        : 12
                                  }
                                },
                                [
                                  _vm.isControlDisabled(
                                    "zost_hodnota_zakl",
                                    "liw_filip__wiz_kalkulacia_produkt__txt_zost_hodnota_zakl"
                                  ) && _vm.$refs.zost_hodnota_zakl.l_visible
                                    ? [
                                        _c(
                                          "v-row",
                                          { attrs: { "no-gutters": "" } },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "f12 gs100" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$refs.zost_hodnota_zakl
                                                      .getLabel
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _c(
                                          "v-row",
                                          {
                                            staticClass: "bold",
                                            attrs: { "no-gutters": "" }
                                          },
                                          [
                                            _c("span", { staticClass: "f16" }, [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$refs.zost_hodnota_zakl
                                                    .stringValue +
                                                    " " +
                                                    _vm.$refs.zost_hodnota_zakl
                                                      .suffix
                                                ) + " "
                                              )
                                            ])
                                          ]
                                        )
                                      ]
                                    : _vm._e(),
                                  _c("numeric-text-box", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.isReversedControlDisabled(
                                          "zost_hodnota_zakl",
                                          "liw_filip__wiz_kalkulacia_produkt__txt_zost_hodnota_zakl"
                                        ),
                                        expression:
                                          "isReversedControlDisabled('zost_hodnota_zakl','liw_filip__wiz_kalkulacia_produkt__txt_zost_hodnota_zakl')"
                                      }
                                    ],
                                    key:
                                      "liw_filip__wiz_kalkulacia_produkt__txt_zost_hodnota_zakl" +
                                      _vm.cisloPlz,
                                    ref: "zost_hodnota_zakl",
                                    attrs: {
                                      dynamic: "",
                                      parentReloaded: _vm.produktFormReloaded,
                                      cisloPlz: _vm.cisloPlz,
                                      dataId:
                                        "liw_filip__wiz_kalkulacia_produkt__txt_zost_hodnota_zakl",
                                      cisloPredmetu: _vm.cisloPredmetu,
                                      suffix: "€",
                                      "hide-details": "",
                                      customLabel: "Základ",
                                      disabled: _vm.isCalculating,
                                      decimalPlaces: 2,
                                      replaceNull: ""
                                    },
                                    on: {
                                      valueChanged:
                                        _vm.zostHodnotaZaklValueChanged,
                                      dataLoaded: function($event) {
                                        return _vm.visiblePoplatkyHeader(
                                          "zost_hodnota",
                                          "zakl"
                                        )
                                      }
                                    }
                                  })
                                ],
                                2
                              ),
                              _c(
                                "v-col",
                                {
                                  staticClass: "pb-4",
                                  attrs: {
                                    cols:
                                      _vm.isControlDisabled(
                                        "zost_hodnota_s_dph",
                                        "liw_filip__wiz_kalkulacia_produkt__txt_zost_hodnota_s_dph"
                                      ) &&
                                      _vm.$refs.zost_hodnota_s_dph.l_visible
                                        ? 6
                                        : 12
                                  }
                                },
                                [
                                  _vm.isControlDisabled(
                                    "zost_hodnota_s_dph",
                                    "liw_filip__wiz_kalkulacia_produkt__txt_zost_hodnota_s_dph"
                                  ) && _vm.$refs.zost_hodnota_s_dph.l_visible
                                    ? [
                                        _c(
                                          "v-row",
                                          { attrs: { "no-gutters": "" } },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "f12 gs100" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$refs.zost_hodnota_s_dph
                                                      .getLabel
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _c(
                                          "v-row",
                                          {
                                            staticClass: "bold",
                                            attrs: { "no-gutters": "" }
                                          },
                                          [
                                            _c("span", { staticClass: "f16" }, [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$refs.zost_hodnota_s_dph
                                                    .stringValue +
                                                    " " +
                                                    _vm.$refs.zost_hodnota_s_dph
                                                      .suffix
                                                ) + " "
                                              )
                                            ])
                                          ]
                                        )
                                      ]
                                    : _vm._e(),
                                  _c("numeric-text-box", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.isReversedControlDisabled(
                                          "zost_hodnota_s_dph",
                                          "liw_filip__wiz_kalkulacia_produkt__txt_zost_hodnota_s_dph"
                                        ),
                                        expression:
                                          "isReversedControlDisabled('zost_hodnota_s_dph','liw_filip__wiz_kalkulacia_produkt__txt_zost_hodnota_s_dph')"
                                      }
                                    ],
                                    key:
                                      "liw_filip__wiz_kalkulacia_produkt__txt_zost_hodnota_s_dph" +
                                      _vm.cisloPlz,
                                    ref: "zost_hodnota_s_dph",
                                    attrs: {
                                      dynamic: "",
                                      parentReloaded: _vm.produktFormReloaded,
                                      cisloPlz: _vm.cisloPlz,
                                      dataId:
                                        "liw_filip__wiz_kalkulacia_produkt__txt_zost_hodnota_s_dph",
                                      cisloPredmetu: _vm.cisloPredmetu,
                                      suffix: "€",
                                      "hide-details": "",
                                      customLabel: _vm.jeDealer
                                        ? "Spolu"
                                        : "Cena s DPH",
                                      disabled: _vm.isCalculating,
                                      decimalPlaces: 2,
                                      replaceNull: ""
                                    },
                                    on: {
                                      valueChanged:
                                        _vm.zostHodnotaSDphValueChanged,
                                      dataLoaded: function($event) {
                                        return _vm.visiblePoplatkyHeader(
                                          "zost_hodnota",
                                          "s_dph"
                                        )
                                      }
                                    }
                                  })
                                ],
                                2
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ]
          ]
        : _vm._e(),
      _vm.jeDealer && _vm.visibleParameterKalkulacieHeader
        ? _c(
            "div",
            { staticClass: "f18 mt-30px", class: { "mb-4": _vm.isMobile } },
            [_vm._v("Parametre kalkulácie")]
          )
        : _vm._e(),
      _c(
        "div",
        { class: { "px-5px": !_vm.isMobile } },
        [
          _c(
            "v-row",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.visibleParameterKalkulacieHeader,
                  expression: "visibleParameterKalkulacieHeader"
                }
              ],
              class: { "flex-column": _vm.isMobile },
              attrs: { "no-gutters": _vm.isMobile }
            },
            [
              _c(
                "v-col",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.parametreVisible.zisk_zakl,
                      expression: "parametreVisible.zisk_zakl"
                    }
                  ],
                  attrs: { md: "4", sm: "12" }
                },
                [
                  _c("numeric-text-box", {
                    key:
                      "liw_filip__wiz_kalkulacia_produkt__txt_zisk" +
                      _vm.cisloPlz,
                    ref: "zisk_zakl",
                    attrs: {
                      parentReloaded: _vm.produktFormReloaded,
                      cisloPlz: _vm.cisloPlz,
                      dataId: "liw_filip__wiz_kalkulacia_produkt__txt_zisk",
                      suffix: "%",
                      cisloPredmetu: _vm.cisloPredmetu,
                      disabled: _vm.isCalculating,
                      decimalPlaces: 4
                    },
                    on: {
                      valueChanged: function(val) {
                        _vm.ziskLoaded(val)
                        _vm.posliProduktFormDirty(true)
                      },
                      dataLoaded: function(val) {
                        _vm.ziskLoaded(val)
                        _vm.visibleParameterKalkulacie("zisk_zakl")
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { md: "4", sm: "12" } },
                [
                  _c("numeric-text-box", {
                    key:
                      "liw_filip__wiz_kalkulacia_produkt__txt_korekcia_refi" +
                      _vm.cisloPlz,
                    ref: "korekcia_refi",
                    attrs: {
                      parentReloaded: _vm.produktFormReloaded,
                      cisloPlz: _vm.cisloPlz,
                      dataId:
                        "liw_filip__wiz_kalkulacia_produkt__txt_korekcia_refi",
                      cisloPredmetu: _vm.cisloPredmetu,
                      suffix: "%",
                      disabled: _vm.isCalculating
                    },
                    on: {
                      valueChanged: function($event) {
                        return _vm.posliProduktFormDirty(true)
                      },
                      dataLoaded: function() {
                        return _vm.visibleParameterKalkulacie("korekcia_refi")
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { md: "4", sm: "12" } },
                [
                  _c("check-box", {
                    key:
                      "liw_filip__wiz_kalkulacia_produkt__btn_ignorovat_prirazky" +
                      _vm.cisloPlz,
                    ref: "ignorovat_prirazky",
                    style: _vm.isMobile
                      ? { marginTop: "0px" }
                      : { marginTop: "20px" },
                    attrs: {
                      parentReloaded: _vm.produktFormReloaded,
                      cisloPlz: _vm.cisloPlz,
                      dataId:
                        "liw_filip__wiz_kalkulacia_produkt__btn_ignorovat_prirazky",
                      cisloPredmetu: _vm.pripad.cisloPredmetu,
                      hideDetails: "",
                      disabled: _vm.isCalculating
                    },
                    on: {
                      valueChanged: function(val) {
                        _vm.changeIgnorovatPrirazky(val)
                      },
                      dataLoaded: function(val) {
                        _vm.ignotovat_prirazky = val == 1 ? true : false
                        _vm.visibleParameterKalkulacie("ignorovat_prirazky")
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "f18 mt-4", class: { "mb-4": _vm.isMobile } },
            [[_vm._v(" Možnosti financovania ")]],
            2
          ),
          !_vm.isMobile ? _c("v-divider", { staticClass: "mt-2" }) : _vm._e(),
          !_vm.isMobile
            ? [
                _c("v-data-table", {
                  attrs: {
                    headers: _vm.headers,
                    items: _vm.kalkulaciaItems,
                    "hide-default-footer": "",
                    "show-select": "",
                    "single-select": false,
                    "disable-pagination": "",
                    "item-key": "pkid"
                  },
                  on: { "item-selected": _vm.onVariantSelected },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "item.data-table-select",
                        fn: function(ref) {
                          var isSelected = ref.isSelected
                          var select = ref.select
                          return [
                            _c(
                              "v-tooltip",
                              {
                                attrs: { left: "", "open-delay": "800" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function(ref) {
                                        var on = ref.on
                                        var attrs = ref.attrs
                                        return [
                                          _c(
                                            "v-simple-checkbox",
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  staticClass:
                                                    "dynamic_check_box",
                                                  attrs: {
                                                    value: isSelected,
                                                    disabled:
                                                      !!_vm.pripad
                                                        .predmetZamknuty ||
                                                      _vm.isCalculating,
                                                    ripple: false
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      return select($event)
                                                    }
                                                  }
                                                },
                                                "v-simple-checkbox",
                                                attrs,
                                                false
                                              ),
                                              on
                                            )
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              },
                              [
                                _vm._v(
                                  " Označením checkboxu vyberiete varianty pre pre tlač ponuky "
                                )
                              ]
                            )
                          ]
                        }
                      },
                      {
                        key: "header.data-table-select",
                        fn: function() {
                          return [
                            _c(
                              "v-tooltip",
                              {
                                attrs: { left: "", "open-delay": "800" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function(ref) {
                                        var on = ref.on
                                        var attrs = ref.attrs
                                        return [
                                          _c(
                                            "v-simple-checkbox",
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value:
                                                        _vm.checkAllVisible,
                                                      expression:
                                                        "checkAllVisible"
                                                    }
                                                  ],
                                                  staticClass:
                                                    "dynamic_check_box",
                                                  attrs: {
                                                    ripple: false,
                                                    disabled: _vm.isCalculating
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      return _vm.allVariantsSelected(
                                                        $event
                                                      )
                                                    }
                                                  },
                                                  model: {
                                                    value: _vm.checkAll,
                                                    callback: function($$v) {
                                                      _vm.checkAll = $$v
                                                    },
                                                    expression: "checkAll"
                                                  }
                                                },
                                                "v-simple-checkbox",
                                                attrs,
                                                false
                                              ),
                                              on
                                            )
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  2739497122
                                )
                              },
                              [
                                _vm._v(
                                  " Označením checkboxu vyberiete všetky varianty pre tlač ponuky "
                                )
                              ]
                            )
                          ]
                        },
                        proxy: true
                      },
                      {
                        key: "header.pozad_cisty_prijem",
                        fn: function(ref) {
                          var header = ref.header
                          return [
                            _c(
                              "span",
                              { staticStyle: { "white-space": "nowrap" } },
                              [
                                _vm._v(" " + _vm._s(header.text) + " "),
                                _c(
                                  "v-tooltip",
                                  {
                                    attrs: { bottom: "", "open-delay": "200" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function(ref) {
                                            var on = ref.on
                                            return [
                                              _c(
                                                "v-icon",
                                                _vm._g(
                                                  {
                                                    staticClass:
                                                      "btn-help text-body-2 ml-2",
                                                    staticStyle: {
                                                      position: "relative"
                                                    },
                                                    attrs: {
                                                      slot: "activator"
                                                    },
                                                    slot: "activator"
                                                  },
                                                  on
                                                ),
                                                [_vm._v("mdi-help-circle")]
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  },
                                  [
                                    _vm._v(
                                      " Požadovaný príjem po odpočítaní životného minima a splátky v danom riadku. "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ]
                        }
                      },
                      {
                        key: "header.rpmn",
                        fn: function(ref) {
                          var header = ref.header
                          return [
                            _c(
                              "span",
                              { staticStyle: { "white-space": "nowrap" } },
                              [
                                _vm._v(" " + _vm._s(header.text) + " "),
                                _c(
                                  "v-tooltip",
                                  {
                                    attrs: { bottom: "", "open-delay": "200" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function(ref) {
                                            var on = ref.on
                                            return [
                                              _c(
                                                "v-icon",
                                                _vm._g(
                                                  {
                                                    staticClass:
                                                      "btn-help text-body-2 ml-2",
                                                    staticStyle: {
                                                      position: "relative"
                                                    },
                                                    attrs: {
                                                      slot: "activator"
                                                    },
                                                    slot: "activator"
                                                  },
                                                  on
                                                ),
                                                [_vm._v("mdi-help-circle")]
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  },
                                  [
                                    _vm._v(
                                      " Ročná percentuálna miera nákladov "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ]
                        }
                      },
                      {
                        key: "item.akontacia",
                        fn: function(ref) {
                          var item = ref.item
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  item.akontacia >= 0
                                    ? item.akontacia.toPercentString(2)
                                    : null
                                ) +
                                " "
                            )
                          ]
                        }
                      },
                      {
                        key: "item.dlzka_leasingu",
                        fn: function(ref) {
                          var item = ref.item
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  item.dlzka_leasingu >= 0
                                    ? item.dlzka_leasingu
                                    : null
                                ) +
                                " "
                            )
                          ]
                        }
                      },
                      {
                        key: "item.prva_platba_s_dph",
                        fn: function(ref) {
                          var item = ref.item
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  item.prva_platba_s_dph >= 0
                                    ? item.prva_platba_s_dph.toEurString()
                                    : null
                                ) +
                                " "
                            )
                          ]
                        }
                      },
                      {
                        key: "item.prva_platba_bez_dph",
                        fn: function(ref) {
                          var item = ref.item
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  item.prva_platba_bez_dph >= 0
                                    ? item.prva_platba_bez_dph.toEurString()
                                    : null
                                ) +
                                " "
                            )
                          ]
                        }
                      },
                      {
                        key: "item.splatka_s_poistenim_s_dph",
                        fn: function(ref) {
                          var item = ref.item
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  item.splatka_s_poistenim_s_dph >= 0
                                    ? item.splatka_s_poistenim_s_dph.toEurString()
                                    : null
                                ) +
                                " "
                            )
                          ]
                        }
                      },
                      {
                        key: "item.splatka_s_poistenim_bez_dph",
                        fn: function(ref) {
                          var item = ref.item
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  item.splatka_s_poistenim_bez_dph >= 0
                                    ? item.splatka_s_poistenim_bez_dph.toEurString()
                                    : null
                                ) +
                                " "
                            )
                          ]
                        }
                      },
                      {
                        key: "item.splatka_s_dph",
                        fn: function(ref) {
                          var item = ref.item
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  item.splatka_s_dph >= 0
                                    ? item.splatka_s_dph.toEurString()
                                    : null
                                ) +
                                " "
                            )
                          ]
                        }
                      },
                      {
                        key: "item.splatka_bez_dph",
                        fn: function(ref) {
                          var item = ref.item
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  item.splatka_bez_dph >= 0
                                    ? item.splatka_bez_dph.toEurString()
                                    : null
                                ) +
                                " "
                            )
                          ]
                        }
                      },
                      {
                        key: "item.klientsky_urok",
                        fn: function(ref) {
                          var item = ref.item
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  item.klientsky_urok >= 0
                                    ? item.klientsky_urok.toPercentString(2)
                                    : "0,00%"
                                ) +
                                " "
                            )
                          ]
                        }
                      },
                      {
                        key: "item.rpmn",
                        fn: function(ref) {
                          var item = ref.item
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  item.rpmn >= 0
                                    ? item.rpmn.toPercentString(2)
                                    : "0,00%"
                                ) +
                                " "
                            )
                          ]
                        }
                      },
                      {
                        key: "item.sp_popl_s_dph",
                        fn: function(ref) {
                          var item = ref.item
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  item.sp_popl_s_dph >= 0
                                    ? item.sp_popl_s_dph.toEurString()
                                    : null
                                ) +
                                " "
                            )
                          ]
                        }
                      },
                      {
                        key: "item.sp_popl_bez_dph",
                        fn: function(ref) {
                          var item = ref.item
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  item.sp_popl_bez_dph >= 0
                                    ? item.sp_popl_bez_dph.toEurString()
                                    : null
                                ) +
                                " "
                            )
                          ]
                        }
                      },
                      {
                        key: "item.zost_hodnota_s_dph",
                        fn: function(ref) {
                          var item = ref.item
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  item.zost_hodnota_s_dph > 0
                                    ? item.zost_hodnota_s_dph.toEurString()
                                    : null
                                ) +
                                " "
                            )
                          ]
                        }
                      },
                      {
                        key: "item.zv_spl_koniec_s_dph",
                        fn: function(ref) {
                          var item = ref.item
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  item.zv_spl_koniec_s_dph > 0
                                    ? item.zv_spl_koniec_s_dph.toEurString()
                                    : null
                                ) +
                                " "
                            )
                          ]
                        }
                      },
                      {
                        key: "item.zost_hodnota_bez_dph",
                        fn: function(ref) {
                          var item = ref.item
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  item.zost_hodnota_bez_dph > 0
                                    ? item.zost_hodnota_bez_dph.toEurString()
                                    : null
                                ) +
                                " "
                            )
                          ]
                        }
                      },
                      {
                        key: "item.zv_spl_koniec_bez_dph",
                        fn: function(ref) {
                          var item = ref.item
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  item.zv_spl_koniec_bez_dph > 0
                                    ? item.zv_spl_koniec_bez_dph.toEurString()
                                    : null
                                ) +
                                " "
                            )
                          ]
                        }
                      },
                      {
                        key: "item.vynos",
                        fn: function(ref) {
                          var item = ref.item
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  item.vynos != null
                                    ? item.vynos.toEurString()
                                    : null
                                ) +
                                " "
                            )
                          ]
                        }
                      },
                      {
                        key: "item.vynosovost_perc",
                        fn: function(ref) {
                          var item = ref.item
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  item.vynosovost_perc != null
                                    ? item.vynosovost_perc.toPercentString(2)
                                    : null
                                ) +
                                " "
                            )
                          ]
                        }
                      },
                      {
                        key: "item.id_color",
                        fn: function(ref) {
                          var item = ref.item
                          return [
                            _c(
                              "v-tooltip",
                              {
                                attrs: { right: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function(ref) {
                                        var on = ref.on
                                        var attrs = ref.attrs
                                        return [
                                          _c(
                                            "div",
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  staticClass: "mr-4",
                                                  class: {
                                                    "semafor semafor-success":
                                                      item.id_color === 1,
                                                    "semafor semafor-warn":
                                                      item.id_color === 2,
                                                    "semafor semafor-negative":
                                                      item.id_color === 3
                                                  }
                                                },
                                                "div",
                                                attrs,
                                                false
                                              ),
                                              on
                                            )
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              },
                              [
                                item.id_color == 1
                                  ? _c("span", [_vm._v("Predschválené")])
                                  : _vm._e(),
                                item.id_color == 2
                                  ? _c("span", [
                                      _vm._v("Na individuálne schválenie")
                                    ])
                                  : _vm._e(),
                                item.id_color == 3
                                  ? _c("span", [_vm._v("Zamietnuté")])
                                  : _vm._e()
                              ]
                            )
                          ]
                        }
                      },
                      {
                        key: "item.pozad_cisty_prijem",
                        fn: function(ref) {
                          var item = ref.item
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  item.pozad_cisty_prijem > 0
                                    ? item.pozad_cisty_prijem.toEurString()
                                    : null
                                ) +
                                " "
                            )
                          ]
                        }
                      },
                      {
                        key: "item.pom_zisk",
                        fn: function(ref) {
                          var item = ref.item
                          return [
                            _c("variant-zisk-text-box", {
                              ref: "variantZisk" + item.pkid,
                              attrs: {
                                value: item.pom_zisk,
                                zakladZisk: _vm.zisk,
                                disabled:
                                  item.zisk_is_enabled == 0 ||
                                  _vm.ignotovat_prirazky ||
                                  _vm.isCalculating,
                                decimalPlaces: 4,
                                tolerancia: 100
                              },
                              on: {
                                input: function(val) {
                                  return _vm.onChangeZiskZakl(val, item)
                                },
                                error: _vm.variantZiskError
                              }
                            })
                          ]
                        }
                      },
                      {
                        key: "item.zlava_zo_splatky",
                        fn: function(ref) {
                          var item = ref.item
                          return [
                            _c("numeric-text-box", {
                              attrs: {
                                value: item.zlava_zo_splatky,
                                suffix: "€",
                                decimalPlaces: 2,
                                textRight: true,
                                hideLabel: true,
                                "hide-details": "",
                                "hide-tooltip": "",
                                disabled: _vm.isCalculating,
                                dense: ""
                              },
                              on: {
                                input: function(val) {
                                  return _vm.onChangeZlavaZakl(val, item)
                                }
                              }
                            })
                          ]
                        }
                      }
                    ],
                    null,
                    true
                  ),
                  model: {
                    value: _vm.selected,
                    callback: function($$v) {
                      _vm.selected = $$v
                    },
                    expression: "selected"
                  }
                })
              ]
            : _vm._l(_vm.kalkulaciaItems, function(item, index) {
                return _c(
                  "v-row",
                  {
                    key: index,
                    staticClass:
                      "mobile-moznosti-financovania-card d-flex flex-wrap",
                    class: { "mobile-card-picked": item.selected },
                    attrs: { "no-gutters": "" },
                    on: {
                      click: function($event) {
                        return _vm.checkMobileItem(item)
                      }
                    }
                  },
                  [
                    _vm.headers.filter(function(h) {
                      return h.value == "id_color"
                    }).length > 0
                      ? _c(
                          "v-col",
                          { staticClass: "pb-2", attrs: { cols: "12" } },
                          [
                            _c(
                              "div",
                              {
                                class: {
                                  "mobile-semafor semafor-success":
                                    item.id_color === 1,
                                  "mobile-semafor semafor-warn":
                                    item.id_color === 2,
                                  "mobile-semafor semafor-negative":
                                    item.id_color === 3
                                }
                              },
                              [
                                _c("div", {
                                  class: {
                                    "semafor-dot success": item.id_color === 1,
                                    "semafor-dot warn": item.id_color === 2,
                                    "semafor-dot negative": item.id_color === 3
                                  }
                                }),
                                _c(
                                  "div",
                                  { staticClass: "f12 pt-3px pl-22px pr-8px" },
                                  [
                                    item.id_color == 1
                                      ? _c("span", [_vm._v("Predschválené")])
                                      : _vm._e(),
                                    item.id_color == 2
                                      ? _c("span", [
                                          _vm._v("Na individuálne schválenie")
                                        ])
                                      : _vm._e(),
                                    item.id_color == 3
                                      ? _c("span", [_vm._v("Zamietnuté")])
                                      : _vm._e()
                                  ]
                                )
                              ]
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._l(
                      _vm.headers.filter(function(h) {
                        return (
                          h.value !== "pom_zisk" &&
                          h.value !== "id_color" &&
                          h.value !== "zlava_zo_splatky"
                        )
                      }),
                      function(header) {
                        return _c(
                          "v-col",
                          {
                            key: header.value,
                            staticClass: "pb-4",
                            class: header.align,
                            attrs: {
                              cols:
                                header.value == "dlzka_leasingu" ||
                                header.value == "rocny_najazd"
                                  ? 12
                                  : 6
                            }
                          },
                          [
                            _c("v-row", { attrs: { "no-gutters": "" } }, [
                              _c("span", { staticClass: "f12 gs100" }, [
                                _vm._v(_vm._s(header.text))
                              ])
                            ]),
                            _c("v-row", { attrs: { "no-gutters": "" } }, [
                              _c("span", { staticClass: "f16 bold" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.transformKalkulaciaItemValue(
                                      header.value,
                                      item[header.value]
                                    )
                                  )
                                )
                              ])
                            ])
                          ],
                          1
                        )
                      }
                    ),
                    _vm.headers.filter(function(h) {
                      return h.value == "zlava_zo_splatky"
                    }).length > 0
                      ? _c(
                          "v-col",
                          { staticClass: "pb-4", attrs: { cols: "12" } },
                          [
                            _c("numeric-text-box", {
                              attrs: {
                                value: item.zlava_zo_splatky,
                                suffix: "€",
                                decimalPlaces: 2,
                                textRight: true,
                                hideLabel: true,
                                "hide-details": "",
                                "hide-tooltip": "",
                                disabled: _vm.isCalculating
                              },
                              on: {
                                input: function(val) {
                                  return _vm.onChangeZlavaZakl(val, item)
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.headers.filter(function(h) {
                      return h.value == "pom_zisk"
                    }).length > 0
                      ? _c(
                          "v-col",
                          { staticClass: "pb-4", attrs: { cols: "12" } },
                          [
                            _c("variant-zisk-text-box", {
                              ref: "variantZisk" + item.pkid,
                              refInFor: true,
                              attrs: {
                                value: item.pom_zisk,
                                zakladZisk: _vm.zisk,
                                disabled:
                                  item.zisk_is_enabled == 0 ||
                                  _vm.ignotovat_prirazky ||
                                  _vm.isCalculating,
                                decimalPlaces: 4,
                                tolerancia: 100,
                                dense: false,
                                textRight: false,
                                hideLabel: false
                              },
                              on: {
                                input: function(val) {
                                  return _vm.onChangeZiskZakl(val, item)
                                },
                                error: _vm.variantZiskError
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  2
                )
              })
        ],
        2
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }